
import React from 'react';
import './customBanner.css';


function CustomBanner({sideText, sideText2, slideUrl}) {

    return (
        <section id="cta-697">
            <div className="cs-container">
                <div className="cs-content">
                    <h2 className="cs-title">{sideText}</h2>
                    <a href={slideUrl} className="cs-button-solid">{sideText2}</a>
                </div>
            </div>
        </section>
    )
}
export default CustomBanner